export const linkPopLiterals = {
  type: { value: 'link_pop', fallback: 'Link Pop' },
  url: { value: 'link_pop_url', fallback: 'Link URL' },
  urlPlaceholder: { value: 'link_pop_url_placeholder', fallback: 'https://example.com' },
  urlRequired: { value: 'admin_reqiured_field', fallback: 'This field is required' },
  urlInvalid: { value: 't_incorrent_link', fallback: 'Incorrect link' },
  urlTooLong: { value: 'long_txt_error', fallback: 'Text too long' },
  preview: { value: 'link_pop_preview', fallback: 'Link preview' },
  refresh: { value: 'ag_refresh', fallback: 'Refresh' },
  hidePreview: { value: 'link_pop_preview_hide', fallback: 'Hide preview' },
  showPreview: { value: 'link_pop_preview_show', fallback: 'Show link preview' },
  openLink: { value: 'link_pop_open_link', fallback: 'Open link' },
  close: { value: 'close', fallback: 'Close' },
  closeHint: { value: 'link_pop_close_after_open_hint', fallback: 'Open the link to enable the close button.' },
  openFailed: { value: 'ag_err_open', fallback: 'Unable to open. Please try again.' },
  acknowledgeFailed: {
    value: 'link_pop_ack_failed',
    fallback: 'The link opened, but we could not confirm it. Please try again.',
  },
} as const
